































































































import { Component, Ref, Vue } from "vue-property-decorator";

@Component
export default class Home extends Vue {
  @Ref()
  private playButton!: HTMLImageElement;
}
